import { render, staticRenderFns } from "./EMelderComponentMeldenBaustein.vue?vue&type=template&id=17817ec2&scoped=true"
import script from "./EMelderComponentMeldenBaustein.vue?vue&type=script&lang=js"
export * from "./EMelderComponentMeldenBaustein.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17817ec2",
  null
  
)

export default component.exports